<div class="modal-overlay" *ngIf="visible">
  <div class="modal">
    <div class="modal-header">
      <h2 *ngIf="!isassign" class="modal-title">
        <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"/>
        </svg>
        Reassign Order
      </h2>
       <h2 *ngIf="isassign" class="modal-title">
        <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"/>
        </svg>
        Assign Order
      </h2>
      <p class="modal-subtitle">{{ modalSubtitle }}</p>
      <button class="close-btn" (click)="closeassignOrder()">
        <svg class="close-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">Select Driver</label>
        <app-driver-select 
          [options]="driverList" 
          [(ngModel)]="selectedDriver"
          placeholder="Select Driver">
        </app-driver-select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeassignOrder()">No</button>
      <button class="btn btn-primary" (click)="assignOrder()" [disabled]="!selectedDriver">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        Yes
      </button>
    </div>
  </div>
</div>
